// extracted by mini-css-extract-plugin
export default {"deleteChild":"DeleteChild__deleteChild___asoY3","button":"DeleteChild__button___sD0uv"};